const initualState = {
    Staff_Name: "",
    Total_Number_Of_Accounts: "",
    Total_Number_Of_Funded_Accounts: "",
    Total_Number_Of_UnFunded_Accounts : ''
  };
  
  export default (state = initualState, action) => {
    switch (action.type) {
      case "GET_AGENT_DATA":
        return { ...state, agentData: action.payload };
      default:
        return state;
    }
  };
  